import React from "react";
import { Link, type LinkProps } from "react-router-dom";

export const RouterLinkBehavior = React.forwardRef<HTMLAnchorElement, LinkProps>(
  function RouterLinkBehavior(itemProps, ref) {
    return <Link ref={ref} {...itemProps} role={undefined} />;
  },
);
